import SpecialtiesCard from '@/components/Cards/SpecialtiesCard'
import Section from '@/components/Section'
import Title from '@/components/Title'
import React from 'react'
import style from '../styles/inst_detail.module.scss'

const Specialties = ({ specialties }): React.ReactElement => {
  return (
    <Section>
      <Title type='h2' theme='h3' className={style.desc__title}>
        Специальности
      </Title>
      <ul className={style.spec_list}>
        {specialties.map(el => {
          return (
            <li key={el.id} className={style.spec__item}>
              <SpecialtiesCard
                name={el.name}
                description={el.detail_text ?? ''}
                form={el.property_study_form_value ?? ''}
                period={el.property_study_term_value ?? ''}
                medicalCheckup={el.property_medicine_value ?? ''}
                url={el.property_special_link_value ?? ''}
              />
            </li>
          )
        })}
      </ul>
    </Section>
  )
}

export default Specialties
